module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_wayo2-3d58adeb56ea0b113cb5cae654695014.png";